import {
	createContext,
	default as React,
	type ReactNode,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { FormsReducer } from "../reducers/FormsReducer";

const FormsContext = createContext({
	state: FormsReducer.getInitialState(),
	actions: FormsReducer.actions,
});

export const useFormsContext = () => useContext(FormsContext);

export const FormsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: FormsReducer.getInitialState(),
		reducers: FormsReducer.caseReducers,
	});

	return (
		<FormsContext.Provider value={{ state, actions }}>
			{children}
		</FormsContext.Provider>
	);
};
